export const BackendRoutes = {
    setProjectStatus : 'project/status',
    deleteProject : 'project/delete'
};